module.exports = __webpack_public_path__ + "static/wednesdays-domaine-0fe092ebc47d6b0700567566314e6a95.png";